import React from "react"
import {
   ComposableMap,
   Geographies,
   Geography,
   Annotation,
} from "react-simple-maps"
import { useTheme } from "styled-components"

const Map = () => {
   const theme = useTheme()
   return (
      <ComposableMap
         projection="geoAzimuthalEqualArea"
         projectionConfig={{
            rotate: [-10.0, -52.0, 0],
            center: [-5, -3],
            scale: 1600,
         }}
         style={{ width: "100%", height: "100%", minHeight: "inherit" }}
      >
         <Geographies
            geography="/mapFeatures.json"
            fill={theme.highLight}
            stroke={theme.secondary}
            strokeWidth={0.5}
         >
            {({ geographies }) =>
               geographies.map((geo) => (
                  <Geography key={geo.rsmKey} geography={geo} />
               ))
            }
         </Geographies>
         <Annotation
            subject={[5.5874991, 46.587805]}
            dx={-90}
            dy={-30}
            connectorProps={{
               stroke: `${theme.text}`,
               strokeWidth: 2,
               strokeLinecap: "round",
            }}
         >
            <text
               x="-8"
               textAnchor="end"
               alignmentBaseline="middle"
               fill={theme.text}
            >
               {"Alièze"}
            </text>
         </Annotation>
      </ComposableMap>
   )
}

export default Map
